import { createHead } from "@vueuse/head"
import { createApp } from "vue"
import App from "./App.vue"
import router from "./router"

//import BlockViewer from '@/components/BlockViewer.vue';
import "@/assets/styles.scss"
//import "@/assets/tailwind.css"
import Aura from "@primeuix/themes/aura"
import PrimeVue from "primevue/config"

// Configuration de moment.js en français
import "@/config/moment"

// Validation de la configuration
import { validateConfig } from "@/config/app"
import { errorService } from "@/service/ErrorService"

import { useEquipeStore } from "@/store/EquipeStore"
import { useProduitStore } from "@/store/ProduitStore"
import { createPinia } from "pinia"
import piniaPluginPersistedState from "pinia-plugin-persistedstate"

// Validation de la configuration au démarrage
try {
  validateConfig()
} catch (error) {
  console.error("Erreur de configuration:", error)
  alert(
    "Erreur de configuration de l'application. Veuillez contacter l'administrateur.",
  )
}

// Configuration des gestionnaires d'erreur
errorService.registerErrorHandler("api", (error) => {
  console.error("Erreur API:", error)
  // Ici vous pourriez ajouter une notification toast par exemple
})

const pinia = createPinia()
pinia.use(piniaPluginPersistedState)

const app = createApp(App)
const head = createHead()

app.use(pinia)
app.use(head)

import { definePreset } from "@primeuix/themes"
const MyPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: "{red.50}",
      100: "{red.100}",
      200: "{red.200}",
      300: "{red.300}",
      400: "{red.400}",
      500: "#ad0d0a",
      600: "{red.600}",
      700: "{red.700}",
      800: "{red.800}",
      900: "{red.900}",
      950: "{red.950}",
    },
  },
})

app.use(router)
app.use(PrimeVue, {
  theme: {
    preset: MyPreset,
    options: {
      darkModeSelector: ".dark",
    },
  },
  locale: {
    firstDayOfWeek: 1,
    dayNames: [
      "dimanche",
      "lundi",
      "mardi",
      "mercredi",
      "jeudi",
      "vendredi",
      "samedi",
    ],
    dayNamesShort: ["dim", "lun", "mar", "mer", "jeu", "ven", "sam"],
    dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
    monthNames: [
      "janvier",
      "février",
      "mars",
      "avril",
      "mai",
      "juin",
      "juillet",
      "août",
      "septembre",
      "octobre",
      "novembre",
      "décembre",
    ],
    monthNamesShort: [
      "jan",
      "fév",
      "mar",
      "avr",
      "mai",
      "jun",
      "jul",
      "aoû",
      "sep",
      "oct",
      "nov",
      "déc",
    ],
    today: "Aujourd'hui",
    clear: "Effacer",
    dateFormat: "dd/mm/yy",
    weekHeader: "Sem",
    // autres options si besoin
  },
})
app.mount("#app")

// Chargement des données en arrière-plan
useProduitStore().getGamme()
useEquipeStore().getEquipe()
